import { http } from '../../../plugins/axios'

const actions = {
  get ({commit}, payload) {
    let url = `company`
    let options = {
      emulateJSON: false
    }
    let params = {
      "perPage": payload.event.item.perPage,
      "page": payload.event.item.page,
      "sortKey": payload.event.item.sortKey,
      "ord": payload.event.item.ord,
      "find": payload.event.item.find !== '' ? payload.event.item.find : undefined
    }
    http.get(url, { params }, options)
      .then(response => {
        commit('onGet',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getCompanyBySuperAdmin ({commit}, payload) {
    let url = `company`
    let options = {
      emulateJSON: false
    }
    let params = {
      "perPage": payload.event.item.perPage,
      "page": payload.event.item.page,
      "sortKey": payload.event.item.sortKey,
      "ord": payload.event.item.ord,
      "find": payload.event.item.find !== '' ? payload.event.item.find : undefined
    }
    http.get(url, { params }, options)
      .then(response => {
        commit('onGetCompanyBySuperAdmin',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getById ({commit}, payload) {
    let url = `company/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(response => {
        commit('onGetById',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  post ({commit}, payload) {
    let url = 'company'
    let options = {
      emulateJSON: false
    }
    http.post(url, payload.event.company, options)
      .then(response => {
        commit('onPost',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  put ({commit}, payload) {
    let url = `company/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.put(url, payload.event.company, options)
      .then(response => {
        commit('onPut',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  updateOwn ({commit}, payload) {
    let url = `company-own`
    let options = {
      emulateJSON: false
    }
    http.put(url, payload.event.company, options)
      .then(response => {
        commit('onUpdateOwn',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  delete ({commit}, payload) {
    let url = `company/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.delete(url, {}, options)
      .then(response => {
        commit('onDelete',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  /**
   * Envia l apeticion para obtener la lista de cuestionarios
   * @param { Funtion } commit Funcion para ejecutar mutation
   * @param { Object } payload Objeto enviado desde el dispatch 
   */
  getChecklist ({commit}, payload) {
    let url = `company-settings`
    let options = {
      emulateJSON: false
    }
    http.get(url, options)
      .then(response => {
        commit('onGetChecklist',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  }
}

export default actions